import { useObserver } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import React, { useContext } from 'react';

import styles from './StepProgress.module.scss';
import { StepsManagerContext } from '../../StepsManager';

export const StepProgress = () => {
  const { stepsManager } = useContext(StepsManagerContext)!;
  const { t } = useTranslation();

  const isEdit = stepsManager.rootStore.moduleStores.socialLinkCreatorEntry?.isEdit;

  return useObserver(() => (
    <ul className={styles.multiSteps}>
      {stepsManager.steps
        .filter(step => step.label !== 'ReEnterPaymentStep')
        .map((step, index) => {
          let resolvedLabel = step.label;

          if (isEdit) {
            if (step.label === 'Create Social Link') {
              resolvedLabel = 'SocialLink_Modify';
            }

            if (step.label === 'Share Social Link') {
              resolvedLabel = 'SocialLink_SaveModification';
            }
          }

          return (
            <li
              key={step.id}
              className={stepsManager.currentStep.id === index + 1 ? styles.isActive : ''}
            >
              <span
                className={
                  stepsManager.currentStep.id === index + 1
                    ? `${styles.textActive} ${styles.textSteps}`
                    : styles.textSteps
                }
              >
                {t(resolvedLabel)}
              </span>
            </li>
          );
        })}
    </ul>
  ));
};

